
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"#282828","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.869 0c-1.26.044-2.194.394-2.8 1.094-.654.831-.796 2.105-.423 3.636-.14.175-.277.47-.277.82.093.7.42 1.15.7 1.368.186.656.647 1.214 1.02 1.477v.573l.19.083c.467.262 1.307.574 1.633.574.327 0 1.065-.3 1.532-.52l.335-.177v-.479c.42-.306.837-.875.977-1.531.28-.219.656-.664.656-1.19 0-.35-.093-.653-.233-.915.187-.613.604-2.314-.19-3.364-.233-.306-.612-.623-1.312-.71C8.304.3 7.615 0 6.87 0zM4.813 9.762c-.327.218-.84.383-1.4.601-1.447.525-3.273 1.143-3.413 3.2 0 .13.052.213.146.3.047.088.137.137.277.137h5.6v-.438c0-1.268.744-2.406.744-2.406l-.365-.738c-.607-.175-1.362-.528-1.502-.615l-.088-.041zm4.33 0l-.174.082c-.14.087-.852.399-1.459.574l-.364.738s.787 1.138.787 2.406V14h5.6a.462.462 0 00.467-.438c-.187-2.056-2.01-2.717-3.456-3.199-.56-.175-1.074-.383-1.4-.601z"}})])
          )
        }
      }
    